import { useEffect } from 'react';
import { Box, ScrollView, useLayout } from '@bonanza-social/moonlight';
import { useNavigation } from '@bonanza-social/navigation';
import { useTranslation } from '@bonanza-social/i18n';
import {
  CashbackSection,
  FreeSpinsSection,
  PendingRewardsSection,
} from '../components';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { fetchMetaGamesCount } from '@bonanza-social/meta-games';

function RewardsScreen() {
  const navigation = useNavigation();
  const { t } = useTranslation('rewards');
  const dispatch = useDispatch();

  useEffect(() => {
    navigation.setOptions({ title: t('rewards') });
  }, [navigation, t]);

  useEffect(() => {
    dispatch(fetchMetaGamesCount());
  }, [dispatch]);

  const [containerLayout, onContainerLayout] = useLayout();

  return (
    <ScrollView>
      <Box gap="space-600" padding="space-400" onLayout={onContainerLayout}>
        <FreeSpinsSection />
        <PendingRewardsSection itemWidth={containerLayout.width} />
        <CashbackSection itemWidth={containerLayout.width} />
      </Box>
    </ScrollView>
  );
}

export default RewardsScreen;
